import urls from "../utils/urls"
import { get,post} from '../utils/http'
const state= {
    
    result:{},
    
    code:0
    
}
const mutations={
    get_agent_user(state,value){

        if(value.type=="post"){
         
            post(urls.admin.agent_user.getagentuser,value).then((result)=>{
               
                state.result=result



            })

        }

    },
    agent_user_add(state,value){
        if(value.type=="get"){
            get(urls.admin.agent_user.add,value).then((result)=>{

                state.result=result


            })

        }

        if(value.type=="post"){
         
            post(urls.admin.agent_user.add,value).then((result)=>{
               
                state.result=result


            })

        }

    },

    agent_user_edit(state,value){
        if(value.type=="get"){
            get(urls.admin.agent_user.edit,value).then((result)=>{

                state.result=result


            })

        }

        if(value.type=="post"){
         
            post(urls.admin.agent_user.edit,value).then((result)=>{
               
                state.result=result


            })

        }

    },
    agent_user_index(state,value){

        post(urls.admin.agent_user.index,value,value).then(result=>{

                console.log('tag', result)
                state.result=result


        })
    },
    lowerLevelAgentUser(state,value){

        post(urls.admin.agent_user.getagentuserlower,value).then((result)=>{

            state.result=result



        })

    },
    
   
 
    

}
const  actions={
    agentUserIndexAction(context,value){
       
        context.commit("agent_user_index",value)
       
    },
    agentUserAddAction(context,value){
       
        context.commit("agent_user_add",value)
       
    },
    agentUserEditAction(context,value){
       
        context.commit("agent_user_edit",value)
       
    },
    getAgentUserAction(context,value){
       
        context.commit("get_agent_user",value)
       
    },
    lowerLevelAgentUserAction(context,value){

        context.commit("lowerLevelAgentUser",value)

    },

    
  
    
  
    
   

}

export default {state,mutations,actions}